<template>
	<div
		class="seasonwrapper bg-wrapper"
		:style="'background-image: url('+$APIURL +'../files/images/backgrounds/fruehling--background-content-hoch.png);'"
	>
		<div class="bg-wrapper--image-one">
			<img :src="$APIURL +'../files/images/backgrounds/fruehling--background-ast-rechts.png'" alt>
		</div>
		<div class="bg-wrapper--image-two">
			<img :src="$APIURL +'../files/images/backgrounds/fruehling--background-ast-links.png'" alt>
		</div>
		<div class="content"></div>
	</div>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		data() {
			return {
				vueroutename: "products",
				apicomponentname: "products"
			};
		},
		created() {},
		methods: {}
	};
</script>

<style lang="scss">
	@import "@/scss/variables.scss";
	@import "@/scss/mixins.scss";
	.bg-wrapper {
		background-repeat: no-repeat;
		background-size: 100% 100%;
		position: relative;

		.bg-wrapper--image-one,
		.bg-wrapper--image-two {
			position: absolute;
			max-width: 200px;
			@include max-screen(1740px) {
				img {
					opacity: 0.3;
				}
			}
			@include min-screen($screen-min-m) {
				max-width: 490px;
			}
		}

		.bg-wrapper--image-one {
			top: 0;
			right: 0;
		}

		.bg-wrapper--image-two {
			bottom: 0;
			left: 0;
		}
	}
</style>